import { useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SuccessModal = ({ isOpen, onClose }: SuccessModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-surface border border-border rounded-lg shadow-elevation-3 max-w-md w-full p-8 animate-in fade-in zoom-in duration-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mb-4">
            <Icon name="CheckCircle2" size={32} color="var(--color-success)" />
          </div>
          <h2 className="text-2xl font-bold text-foreground mb-2">
            Request Submitted Successfully!
          </h2>
          <p className="text-muted-foreground mb-6">
            Thank you for your interest in collaborating! I'll review your
            request and get back to you within 24-48 hours.
          </p>
          <div className="w-full space-y-3">
            <Button
              variant="default"
              size="lg"
              fullWidth
              iconName="MessageCircle"
              iconPosition="left"
              onClick={() => {
                window.open("https://wa.me/qr/MIPMGLGF4RZ5O1", "_blank");
                onClose();
              }}
            >
              Continue on WhatsApp
            </Button>
            <Button
              variant="outline"
              size="lg"
              fullWidth
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;